// extracted by mini-css-extract-plugin
export var addButton = "_jj-0";
export var border = "_jj-8";
export var check = "_jj-h";
export var danger = "_jj-6";
export var dropdownContainer = "_jj-1";
export var editModalBody = "_jj-j";
export var footerContainer = "_jj-i";
export var fullWidth = "_jj-a";
export var hide = "_jj-9";
export var icon = "_jj-3";
export var input = "_jj-7";
export var inputFlex = "_jj-b";
export var inputWrapper = "_jj-c";
export var manualFocus = "_jj-5";
export var optionButton = "_jj-4";
export var pillWrapper = "_jj-e";
export var pointer = "_jj-2";
export var showOverflow = "_jj-f";
export var tagsFlex = "_jj-d";
export var xButton = "_jj-g";